export default (url) => new Promise((resolve, reject) => {
    if (typeof url !== 'string' || !url.trim()) {
        reject(new Error('Пустой URL схемы'));
        return;
    }

    const img = new Image();

    img.onload = (event) => {
        const src = event.currentTarget.getAttribute('src');

        if (src.indexOf('.svg') === -1) {
            resolve({width: event.currentTarget.width, height: event.currentTarget.height});
            return;
        }

        $.get(src, (svgxml) => {
            try {
                const viewBox = svgxml.documentElement.getAttribute('viewBox');
                const dimensions = viewBox && viewBox.trim().split(/[\s,]+/);

                if (!dimensions || dimensions.length !== 4) {
                    throw new Error('В SVG отсутствует корректный viewBox');
                }

                const width = Number(dimensions[2]);
                const height = Number(dimensions[3]);

                if (!(width > 0 && height > 0)) {
                    throw new Error('Некорректные размеры SVG');
                }

                resolve({width, height});
            } catch (error) {
                reject(error);
            }
        }, 'xml').fail(reject);
    };
    img.onerror = () => reject(new Error(`Не удалось загрузить изображение: ${url}`));
    img.src = url;
});
